import { createContext } from 'react';
export const ConfigurationContext = createContext({});